export default {"src":"/_next/static/media/content-360deg.368abdb7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};